import { useAuth0 } from "@auth0/auth0-react"
import { useCallback, useEffect, useState } from "react"

export const useGetGroupById = (groupId) => {
	const [isLoading, setIsLoading] = useState(true)
	const [isError, setIsError] = useState(true)
	const [data, setData] = useState(null)
	const { getAccessTokenSilently } = useAuth0()

	const getGroupById = useCallback(async () => {
		setIsLoading(true)
		fetch(
			new Request(process.env.REACT_APP_SESSION_ADDR + "/api/v2/group/" + groupId, {
				method: "GET",
				headers: new Headers({
					"authorization": "Bearer " + (await getAccessTokenSilently()),
					"Content-Type": "application/json"
				})
			})
		)
			.then((response) => {
				if (response.ok) {
					console.log("Get Group by Id successfully!")
					return response.json()
				} else if (response.statusText === "Unauthorized") {
					throw new Error("Unauthorized")
				} else {
					throw new Error("Something went wrong")
				}
			})
			.then((result) => {
				console.log(result)
				setIsError(false)
				setData(result ? result : null)
			})
			.catch((err) => {
				setIsError(true)
				console.log(err)
			})
			.finally(() => setIsLoading(false))
	}, [getAccessTokenSilently])

	useEffect(() => {
		return () => {
			setIsError(null)
			setIsLoading(null)
		}
	}, [])

	return { isLoading, data, setData, isError, getGroupById }
}
